"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_fusion_bs_switch_1 = require("@hotelplan/core.fusion.bs-switch");
const graphql_types_1 = require("@hotelplan/graphql.types");
const TravelDates_mappers_1 = require("./TravelDates.mappers");
const TravelDates_utils_1 = require("./TravelDates.utils");
const TravelDatesDurationDropdown_1 = __importDefault(require("./TravelDatesDurationDropdown"));
const WeekDaysList_1 = __importDefault(require("./WeekDaysList"));
const Header = styled_components_1.default.div(({ theme }) => theme.travelDates.headerCss);
const HeaderGroup = styled_components_1.default.div(({ theme }) => theme.travelDates.headerGroupCss);
const FlexibleDurationDropdown = (0, styled_components_1.default)(TravelDatesDurationDropdown_1.default)({
    maxWidth: '200px',
    flex: 2,
});
function TravelDatesControllers(props) {
    const { t } = (0, next_i18next_1.useTranslation)(['search', 'forms']);
    const { hasCustomWeekDayElement, customConfiguration, travelDatesState, setDuration, setSearchType, children, labelWithColon = true, customFlexibleDurationValues, labelExact, } = props;
    const { duration, searchType, extraDurations, defaults } = travelDatesState;
    const durationValues = (0, TravelDates_mappers_1.getDurationValuesBySearchType)(searchType, customFlexibleDurationValues);
    const durationValuesWithExtraDurations = [
        ...durationValues,
        ...extraDurations,
    ];
    const durationOptions = durationValuesWithExtraDurations.map(value => {
        return {
            label: (0, TravelDates_utils_1.formatDuration)(t, value),
            value,
        };
    });
    const onDurationSelect = (nextDuration) => {
        const durationValue = JSON.parse(nextDuration);
        setDuration(durationValue);
    };
    const hideExactSelection = !(customConfiguration === null || customConfiguration === void 0 ? void 0 : customConfiguration.onlyExact) || hasCustomWeekDayElement;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        hideExactSelection && (react_1.default.createElement(Header, { className: "header" },
            !(customConfiguration === null || customConfiguration === void 0 ? void 0 : customConfiguration.onlyExact) && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(HeaderGroup, { className: "header-group" },
                    react_1.default.createElement("span", { className: "label-exact" }, labelExact ? (labelExact) : (react_1.default.createElement(react_1.default.Fragment, null,
                        t('dates.heading'),
                        labelWithColon && ':'))),
                    react_1.default.createElement(core_fusion_bs_switch_1.BsSwitch, { testId: "travelDatesSearchPeriodSwitcher", name: "searchType", valueFirst: graphql_types_1.SearchPeriodType.Exact, valueSecond: graphql_types_1.SearchPeriodType.Flexible, checkedValue: searchType, labelFirst: t('dates.exact'), labelSecond: t('dates.flexible'), onCheck: value => setSearchType(value, defaults) })),
                children,
                searchType === graphql_types_1.SearchPeriodType.Flexible && (react_1.default.createElement(HeaderGroup, { className: "header-group header-group-duration-dropdown" },
                    react_1.default.createElement("span", { className: "label-flexible" },
                        t('dates.duration.heading'),
                        labelWithColon && ':'),
                    react_1.default.createElement(FlexibleDurationDropdown, { currentDuration: duration, durations: durationOptions, onDurationSelect: onDurationSelect, className: "travel-dates-duration-dropdown" }))))),
            hasCustomWeekDayElement && react_1.default.createElement(WeekDaysList_1.default, { firstDayOfWeek: 1 }))),
        !hideExactSelection && children));
}
exports.default = TravelDatesControllers;
//# sourceMappingURL=TravelDatesControllers.js.map